export const getRootContextPath = () => {
  const contextPathElementCandidate = <HTMLElement | null>document.querySelector('[data-root-context-path]');
  let contextPath = contextPathElementCandidate?.dataset.rootContextPath || '';
  contextPath = contextPath.trim();
  contextPath = contextPath.replace(/\/+$/, '');
  contextPath = contextPath.replace(/\/+/g, '/');
  return contextPath;
};
